export default __webpack_public_path__ + "static/media/bedroom.3e433a7e.jpg";